function IconRestore({ }) {
  return (
    <svg viewBox="0 0 50 50"><path d="M15,20V16a1,1,0,0,1,1-1h4m14,5V16a1,1,0,0,0-1-1H29M15,29v4a1,1,0,0,0,1,1h4m9,0h4a1,1,0,0,0,1-1V29" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path> <rect x="21" y="21" width="7" height="7" rx="1" fill="currentColor"></rect></svg>
  );
}

export default IconRestore;
